import React from 'react';
import ReconciliationCenter from './ReconciliationCenter';

export default function ReconciliationAccounting() {
	return <ReconciliationCenter domain="Accounting" />;
}
